import React from 'react';
import { StarIcon } from 'lucide-react';
const HeroSection = () => {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="w-full bg-gradient-to-b from-[#DEEFE1] to-white" data-id="element-184">
      <div className="container mx-auto px-4 py-12 md:py-20" data-id="element-185">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-186">
          <div className="md:w-1/2" data-id="element-187">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#438A52] mb-4" data-id="element-188">
              Son las 5 PM. No hay nada listo. Tus hijos tienen hambre. Tú estás
              agotada.
            </h1>
            <h2 className="text-2xl md:text-3xl font-bold text-[#438A52] mb-6" data-id="element-189">
              Descubre cómo tener la cena lista sin estrés desde hoy.
            </h2>
            <div className="mb-6" data-id="element-190">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eeaY1rVHmCe2VF51GB3M9S/MockUp_-_Editado.jpg" alt="Sistema completo La Cena Que Te Salva con ebooks y bonos" className="w-full rounded-lg shadow-md" data-id="element-191" />
            </div>
            <p className="text-lg text-gray-700 mb-6" data-id="element-192">
              Recibe el sistema completo para resolver la cena… por menos de lo
              que cuesta un café ☕
            </p>
            <div className="flex items-center mb-6" data-id="element-193">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-194" />)}
              <span className="ml-2 text-gray-700" data-id="element-195">
                <strong data-id="element-196">4.9/5</strong> (87 reseñas)
              </span>
            </div>
            <button className="bg-[#FF6B3C] hover:bg-[#E05A30] text-white font-bold py-3 px-8 rounded-lg text-lg transition duration-300 shadow-lg" onClick={scrollToOffer} data-id="element-197">
              Accede por menos que un café ☕
            </button>
            <p className="mt-3 text-sm text-gray-600" data-id="element-198">
              Acceso instantáneo al ebook + todos los bonos
            </p>
          </div>
          <div className="md:w-1/2" data-id="element-199">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qSQnpzRs6Qv86N9yLtXteC/Testimonio_Karen_%281%29.jpg" alt="Creadora de La Cena Que Te Salva con comidas preparadas" className="w-full max-w-md mx-auto rounded-lg shadow-xl" data-id="element-200" />
          </div>
        </div>
      </div>
    </div>;
};
export default HeroSection;